/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import { Skeleton } from '@e2n/ui';
import { ArbeitsbereichMultiSelect } from '@/domain/mitarbeiter/features/anlageassistent/components/ArbeitsbereichMultiSelect';
import { ArbeitsbereichSelect } from '@/domain/mitarbeiter/features/anlageassistent/components/ArbeitsbereichSelect';
import { ErfahrungslevelSelect } from '@/domain/mitarbeiter/features/anlageassistent/components/ErfahrungslevelSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function Arbeitsbereiche() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const { currentStandort } = useStandortContext();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7">
          {ctx.getCurrentSubStep()?.title}
        </h2>
        <p className="text-neutrals-800 text-sm font-normal leading-5">
          {t(
            'domain.mitarbeiter.create.steps.person.arbeitsbereiche.description',
          )}
        </p>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
        <form.AppField name="person.arbeitsbereiche.primaererArbeitsbereich">
          {(field) => (
            <FieldBase
              isRequired
              label={t(
                'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.label',
              )}
              infoText={t(
                `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.info`,
              )}>
              <Suspense fallback={<Skeleton className="w-108 h-10" />}>
                <ArbeitsbereichSelect
                  value={field.state.value}
                  handleChange={(value) => {
                    field.handleChange(value);
                    const sekundaereArbeitsbereiche = form.getFieldValue(
                      'person.arbeitsbereiche.sekundaereArbeitsbereiche',
                    );
                    if (sekundaereArbeitsbereiche?.includes(value)) {
                      form.setFieldValue(
                        'person.arbeitsbereiche.sekundaereArbeitsbereiche',
                        sekundaereArbeitsbereiche.filter((ab) => ab !== value),
                      );
                    }
                  }}
                />
              </Suspense>
            </FieldBase>
          )}
        </form.AppField>
        <form.AppField name="person.arbeitsbereiche.erfahrungslevel">
          {(field) => (
            <FieldBase
              label={t(
                'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.label',
              )}>
              <ErfahrungslevelSelect
                value={field.state.value ?? ''}
                handleChange={(value) => field.handleChange(value)}
              />
            </FieldBase>
          )}
        </form.AppField>
        {currentStandort.qualifikationenEnabled && (
          <form.AppField name="person.arbeitsbereiche.sekundaereArbeitsbereiche">
            {(field) => (
              <FieldBase
                label={t(
                  'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.sekundaereArbeitsbereiche.label',
                )}
                infoText={t(
                  `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.sekundaereArbeitsbereiche.info`,
                )}>
                <Suspense fallback={<Skeleton className="w-108 h-10" />}>
                  <form.Subscribe
                    selector={(state) => [
                      state.values.person.arbeitsbereiche
                        .primaererArbeitsbereich,
                    ]}>
                    {([primaererArbeitsbereich]) => (
                      <ArbeitsbereichMultiSelect
                        values={field.state.value}
                        handleChange={(value) => field.handleChange(value)}
                        hideArbeitsbereiche={
                          primaererArbeitsbereich
                            ? [primaererArbeitsbereich]
                            : []
                        }
                      />
                    )}
                  </form.Subscribe>
                </Suspense>
              </FieldBase>
            )}
          </form.AppField>
        )}
      </div>
    </div>
  );
}
